import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { takeUntil } from 'rxjs/operators';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { DispatchCenterService } from 'src/app/component/dashboard/dashboard-service/dispatch-center-service';
import { LevelOfServiceService } from 'src/app/component/level-of-service/service/level-of-service.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-dispatch-driver-trips-modal',
  templateUrl: './dispatch-driver-trips-modal.component.html',
  styleUrls: ['./dispatch-driver-trips-modal.component.css']
})
export class DispatchDriverTripsModalComponent implements OnInit {
  @Input() driverId;
  @Input() date?: any;
  @Output() close = new EventEmitter<any>();
  search;
  trips = [];
  preLevelOfServices = {};
  preSpaceTypes = {};
  preCooperates = {}
  constructor(
    private corporateService : CorporateService,
    private levelOfServiceService : LevelOfServiceService,
    private dispatchCenterService: DispatchCenterService
    ) { }

  ngOnInit() {
    this.getLevelOfService();
    this.getSpaceTypes();
    this.getDriverTrips();
    this.getCorporate();
  }

  closeModal() {
    this.close.emit();
  }

  getDriverTrips() {
    const payload = {
      driver: this.driverId
    }
    if (this.date) {
      payload['scheduleTime'] = this.date[0];
    }
    this.dispatchCenterService.getDriverTrips(payload).subscribe(data => {
      if (data) {
        this.trips = data.assigns;
      }
    })
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({status: 'active'})
      .subscribe(data => {
        if (data) {
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      })
  }


  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({status: 'active'})
      .subscribe(data => {
        if (data) {
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .subscribe(data => {
        if (data ) {
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

}
